import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TemplateAccess } from '../../../../models/template-access';
import { ActivatedRoute, Router } from '@angular/router';
import { AgilityRiskService } from '../../../../providers/agility-risk.service';
import { AgilityRiskSpinnerService } from '../../../../providers/agility-risk-spinner.service';
import { AgilityRiskNavigationService } from '../../../../providers/agility-risk-navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of, Subject } from 'rxjs';
import { AgilityRiskMessageService } from '../../../../providers/agility-risk-message.service';
import { TemplateAccessStep } from '../../../../agility-risk.enum';
import { AgilityRiskFilterService } from '../../../../providers/agility-risk-filter.service';
import { RiskTemplateFilter } from '../../../../models/risk-template-filter';
import { BaseComponent } from '../../../shared/base/base.component';
import * as _ from 'lodash';

@Component({
  selector: 'lib-access-manager',
  templateUrl: './access-manager.component.html',
  styleUrls: ['./access-manager.component.scss']
})
export class AccessManagerComponent extends BaseComponent implements OnInit {
  emitFilters: Subject<RiskTemplateFilter> = new Subject();
  onStepChange: Subject<number> = new Subject();
  templateAccessId: string;
  templateAccess: TemplateAccess;
  steps: MenuItem[];
  activeIndex: number = 0;
  previousActiveIndex: number = 0;
  filtersForApp: any = [];
  stepNames: Array<string> = [
    'lib-access-manager-manager',
    'lib-access-manager-template',
    'lib-access-manager-department',
    'lib-access-manager-resource',
    'lib-access-manager-site',
    'lib-access-manager-third-party'
  ];
  templateAccessStep = TemplateAccessStep;
  private originalTemplateAccess: TemplateAccess;

  constructor(public activatedRoute: ActivatedRoute,
              private router: Router,
              private navigationService: AgilityRiskNavigationService,
              private agilityService: AgilityRiskService,
              private translateService: TranslateService,
              private spinner: AgilityRiskSpinnerService,
              private messageService: AgilityRiskMessageService,
              private filterService: AgilityRiskFilterService,) {
    super(activatedRoute);
    this.templateAccessId = this.activatedRoute.snapshot?.params?.id;
    this.steps = [
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.selectManager'),
        styleClass: 'icon manager',
        disabled: false,
        command: (event: any) => {
          this.clickStep(event);
        }
      },
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.templateSelection'),
        styleClass: 'icon template grey',
        disabled: true,
        command: (event: any) => {
          this.clickStep(event);
        }
      },
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.assignDepartments'),
        styleClass: 'icon department grey',
        disabled: true,
        command: (event: any) => {
          this.clickStep(event);
        }
      },
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.assignResources'),
        styleClass: 'icon resource grey',
        disabled: true,
        command: (event: any) => {
          this.clickStep(event);
        }
      },
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.assignSites'),
        styleClass: 'icon site grey',
        disabled: true,
        command: (event: any) => {
          this.clickStep(event);
        }
      },
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.assignThirdParty'),
        styleClass: 'icon thirdParty grey',
        disabled: true,
        command: (event: any) => {
          this.clickStep(event);
        }
      },
      {
        label: this.translateService.instant('riskTemplates.manageAccess.steps.summary'),
        styleClass: 'icon summary grey',
        disabled: true,
        command: (event: any) => {
          this.clickStep(event);
        }
      }
    ];
  }

  get isChanged(): boolean {
    let changed: boolean = false;
    switch (this.activeIndex) {
      case TemplateAccessStep.manager:
        if (!_.isEqual(this.originalTemplateAccess.owner, this.templateAccess.owner)) {
          changed = true;
        }
        break;
      case TemplateAccessStep.template:
        if (!_.isEqual(this.originalTemplateAccess.riskTemplates, this.templateAccess.riskTemplates)
          || this.originalTemplateAccess.allTemplates !== this.templateAccess.allTemplates) {
          changed = true;
        }
        break;
      case TemplateAccessStep.department:
        if (!_.isEqual(this.originalTemplateAccess.riskAffectedDepartments, this.templateAccess.riskAffectedDepartments)
          || this.originalTemplateAccess.allDepartments !== this.templateAccess.allDepartments) {
          changed = true;
        }
        break;
      case TemplateAccessStep.resource:
        if (!_.isEqual(this.originalTemplateAccess.riskAffectedResources, this.templateAccess.riskAffectedResources)
          || this.originalTemplateAccess.allResources !== this.templateAccess.allResources) {
          changed = true;
        }
        break;
      case TemplateAccessStep.site:
        if (!_.isEqual(this.originalTemplateAccess.riskAffectedSites, this.templateAccess.riskAffectedSites)
          || this.originalTemplateAccess.allSites !== this.templateAccess.allSites) {
          changed = true;
        }
        break;
      case TemplateAccessStep.thirdParty:
        if (!_.isEqual(this.originalTemplateAccess.riskAffectedVendors, this.templateAccess.riskAffectedVendors)
          || this.originalTemplateAccess.allVendors !== this.templateAccess.allVendors) {
          changed = true;
        }
        break;
      case TemplateAccessStep.summary:
        if (!_.isEqual(this.originalTemplateAccess.riskTemplates, this.templateAccess.riskTemplates)
          || this.originalTemplateAccess.allTemplates !== this.templateAccess.allTemplates) {
          changed = true;
        }
        break;
    }
    return changed;
  }

  get isNextDisabled(): boolean {
    let disabled = false;
    if (this.activeIndex === this.templateAccessStep.manager && this.templateAccess?.owner == null) {
      disabled = true;
    }
    return disabled;
  }

  onModelChange() {
    if (this.isChanged) {
      console.log('template access is changed');
      this.isDirty = true;
    }
  }

  applyFilters(filter) {
    this.emitFilters.next(filter);
  }

  ngOnInit(): void {
    if (this.templateAccessId) {
      this.spinner.start();
      this.agilityService.getManagerAccess(this.templateAccessId).subscribe({
        next: (res: TemplateAccess) => {
          this.templateAccess = res;
          this.setAccess();
          this.originalTemplateAccess = _.cloneDeep(this.templateAccess);
          this.getFilters();
          this.spinner.stop();
        },
        error: _ => {
          this.spinner.stop();
        }
      });
    } else {
      this.getFilters();
      this.templateAccess = new TemplateAccess();
      this.originalTemplateAccess = new TemplateAccess();
    }
  }

  getFilters() {
    if (this.activeIndex !== 6) {
      this.filterService.getFiltersForComponent(this.stepNames[this.activeIndex]).subscribe((filters) => {
        this.filtersForApp = filters;
      });
    }
  }

  clickStep(event: any): void {
    if (this.previousActiveIndex !== this.activeIndex) {
      this.saveManagerAccess().subscribe({
        next: _ => {
          this.previousActiveIndex = this.activeIndex;
          this.onStepChange.next(this.activeIndex);
          this.getFilters();
        },
        error: err => {
          this.activeIndex = this.previousActiveIndex;
          this.getFilters();
          this.onStepChange.next(this.activeIndex);
        }
      });
    }
  }

  next() {
    if (this.activeIndex < TemplateAccessStep.summary && !this.isNextDisabled) {
      if (this.activeIndex === TemplateAccessStep.manager && this.templateAccess.owner == null) {
        this.messageService.error(this.translateService.instant('riskTemplates.manageAccess.managerRequiredMsg'));
        return;
      }
      this.saveManagerAccess().subscribe({
        next: _ => {
          this.activeIndex++;
          this.onStepChange.next(this.activeIndex);
          this.getFilters();
          this.previousActiveIndex = this.activeIndex;
          const step = this.steps[this.activeIndex];
          step.styleClass = step.styleClass.replace(' grey', '');
          step.disabled = false;
        },
        error: err => {
        }
      });
    }
  }

  previous() {
    if (this.activeIndex > TemplateAccessStep.manager) {
      this.saveManagerAccess().subscribe({
        next: _ => {
          this.activeIndex--;
          this.previousActiveIndex = this.activeIndex;
          this.onStepChange.next(this.activeIndex);
          this.getFilters();
        },
        error: err => {
        }
      });
    }
  }

  saveManagerAccess(): Observable<TemplateAccess> {
    if (this.isChanged) {
      const subject: Subject<TemplateAccess> = new Subject<TemplateAccess>();
      this.spinner.start(this.translateService.instant('riskTemplates.manageAccess.savingChanges'));
      this.setAccess();
      this.agilityService.saveManagerAccess(this.templateAccess).subscribe({
        next: (res: any) => {
          if (this.templateAccess.id == null) {
            this.templateAccess.id = res.id;
          }
          this.isDirty = false;
          this.templateAccess = res;
          this.originalTemplateAccess = _.cloneDeep(this.templateAccess);
          subject.next();
          this.messageService.success(this.translateService.instant('riskTemplates.manageAccess.managerAccessSaved'));
          this.spinner.stop();
        },
        error: err => {
          subject.error(err);
          this.messageService.error(this.translateService.instant('riskTemplates.manageAccess.failedSaveManagerAccess'));
          this.isDirty = true;
          this.templateAccess = _.cloneDeep(this.originalTemplateAccess);
          this.spinner.stop();
        }
      });
      return subject;
    } else {
      return of(null);
    }
  }

  setAccess() {
    if (this.templateAccess.allTemplates) {
      this.templateAccess.riskTemplates = [];
    }
    if (this.templateAccess.allDepartments) {
      this.templateAccess.riskAffectedDepartments = [];
    }
    if (this.templateAccess.allResources) {
      this.templateAccess.riskAffectedResources = [];
    }
    if (this.templateAccess.allSites) {
      this.templateAccess.riskAffectedSites = [];
    }
    if (this.templateAccess.allVendors) {
      this.templateAccess.riskAffectedVendors = [];
    }
  }

  cancel() {
    this.router.navigateByUrl(`${this.navigationService.moduleBaseAddress}/risk-template-access`);
  }

  done() {
    this.router.navigateByUrl(`${this.navigationService.moduleBaseAddress}/risk-template-access`);
  }
}

